export const teamUsers = [
  {
    id: 1,
    fullName: "Олександр Петренко",
    email: "o.petrenko@clentyra.com",
    description: "Опис",
  },
  {
    id: 2,
    fullName: "Марія Коваленко",
    email: "m.kovalenko@clentyra.com",
    description: "Опис",
  },
  {
    id: 3,
    fullName: "Андрій Мельник",
    description: "Опис",
    email: "a.melnyk@clentyra.com",
  },
  {
    id: 4, 
    fullName: "Ірина Шевченко",
    description: "Опис",
    email: "i.shevchenko@clentyra.com",
  },
  {
    id: 5,
    fullName: "Василь Бондаренко",
    description: "Опис",
    email: "v.bondarenko@clentyra.com",
  },
  {
    id: 6,
    fullName: "Наталія Ковальчук",
    description: "Опис",
    email: "n.kovalchuk@clentyra.com",
  },
]

const employeesData = [
  {
    isChecked: false,
    fullName: "Олександр Петренко",
    position: "Старший розробник",
    email: "o.petrenko@clentyra.com",
    phone: "+380501234567"
  },
  {
    isChecked: false,
    fullName: "Марія Коваленко",
    position: "UI/UX дизайнер",
    email: "m.kovalenko@clentyra.com",
    phone: "+380672345678"
  },
  {
    isChecked: false,
    fullName: "Андрій Мельник",
    position: "DevOps інженер",
    email: "a.melnyk@clentyra.com",
    phone: "+380633456789"
  },
  {
    isChecked: false,
    fullName: "Ірина Шевченко",
    position: "Проєктний менеджер",
    email: "i.shevchenko@clentyra.com",
    phone: "+380994567890"
  },
  {
    isChecked: false,
    fullName: "Василь Бондаренко",
    position: "Backend розробник",
    email: "v.bondarenko@clentyra.com",
    phone: "+380505678901"
  },
  {
    isChecked: false,
    fullName: "Наталія Ковальчук",
    position: "HR менеджер",
    email: "n.kovalchuk@clentyra.com",
    phone: "+380676789012"
  },
  {
    isChecked: false,
    fullName: "Дмитро Савченко",
    position: "Frontend розробник",
    email: "d.savchenko@clentyra.com",
    phone: "+380637890123"
  },
  {
    isChecked: false,
    fullName: "Олена Григоренко",
    position: "QA інженер",
    email: "o.hryhorenko@clentyra.com",
    phone: "+380998901234"
  },
  {
    isChecked: false,
    fullName: "Ігор Литвиненко",
    position: "Системний адміністратор",
    email: "i.lytvynenko@clentyra.com",
    phone: "+380509012345"
  },
  {
    isChecked: false,
    fullName: "Тетяна Захарченко",
    position: "Бізнес аналітик",
    email: "t.zakharchenko@clentyra.com",
    phone: "+380670123456"
  },
  {
    isChecked: false,
    fullName: "Павло Данилюк",
    position: "Python розробник",
    email: "p.danyliuk@clentyra.com",
    phone: "+380631234567"
  },
  {
    isChecked: false,
    fullName: "Софія Марченко",
    position: "Маркетинг менеджер",
    email: "s.marchenko@clentyra.com",
    phone: "+380992345678"
  },
  {
    isChecked: false,
    fullName: "Роман Ткаченко",
    position: "Data Science інженер",
    email: "r.tkachenko@clentyra.com",
    phone: "+380503456789"
  },
  {
    isChecked: false,
    fullName: "Юлія Панченко",
    position: "Офіс менеджер",
    email: "y.panchenko@clentyra.com",
    phone: "+380674567890"
  },
  {
    isChecked: false,
    fullName: "Максим Кравчук",
    position: "Mobile розробник",
    email: "m.kravchuk@clentyra.com",
    phone: "+380635678901"
  },
  {
    isChecked: false,
    fullName: "Вікторія Лисенко",
    position: "Технічний письменник",
    email: "v.lysenko@clentyra.com",
    phone: "+380996789012"
  }
];

export default employeesData;